import React from 'react';
import { FaSpinner, FaCheck } from 'react-icons/fa';
import './FullScreenLoader.css';

const FullScreenLoader = ({ isVisible, message = 'Saving your changes...', subtext = 'Please wait, this will take a moment', showSuccess = false }) => {
    if (!isVisible && !showSuccess) return null;

    return (
        <div className={`fullscreen-loader-overlay ${isVisible || showSuccess ? 'active' : ''}`}>
            <div className="fullscreen-loader-content">
                {showSuccess ? (
                    <>
                        <div className="loader-success-icon">
                            <FaCheck />
                        </div>
                        <div className="loader-text">Saved successfully!</div>
                    </>
                ) : (
                    <>
                        <div className="loader-spinner">
                            <FaSpinner className="spinning" />
                        </div>
                        <div className="loader-text">{message}</div>
                        {subtext && <div className="loader-subtext">{subtext}</div>}
                    </>
                )}
            </div>
        </div>
    );
};

export default FullScreenLoader;
